import classnames from "classnames";

import Styles from "./index.module.scss";

export function Spacer({ subtle = false }: { subtle?: boolean }) {
  return <span className={classnames(Styles.spacer, subtle && Styles.subtle)} />;
}
